/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Коллекция для последних просмотренных
   */
  app.Recent = app.Collection.extend({
    
    model: app.RecentItem,
    
    beforeRun: function () {
      // заполняем коллекцию при инициализации
      if (app.jsonRecent !== undefined && app.jsonRecent.length) {
        app.recent.reset(app.jsonRecent);
      }
    }
    
  });
})();

}.call(window));